import React, { useEffect, useState } from "react";
import PdfLogo from "./pdftemplates/PdfLogo";
import { useNavigate, useParams } from "react-router-dom";
import PdfSubheading from "./pdftemplates/PdfSubheading";
import request, { gql } from "graphql-request";
import PdfShppingAddress from "./pdftemplates/PdfShppingAddress";
import ReusablePDFLayout from "./ReusablePdf";
import PdfTabel from "./pdftemplates/PdfTabel";
import BankDeatils from "./pdftemplates/BankDeatils";
import TermsAndConditionPdf from "./pdftemplates/TermsAndConditionPdf";
import UnderTabelbox from "./pdftemplates/UnderTabelbox";
import BASEURL from "../../Utils/Baseurl";
 
const qoutationpdf = gql`
  query qoutationpdf($id: String!) {
    getQuotationDetail(id: $id) {
      id
      qtnid
      quoteDate
      user {
        username
        email
      }
      customer
      relatedName
      customerCity
      customerState
      customerCountry
      customerZipcode
      customerGst
      billingAddress
      discount
      preferredBy {
        username
        email
      }
      quotationproductsSet {
        productName {
          productName
          description
          HSNNumber
          SKU
          Tax
        }
        cgstTax
        cgstTaxamount
        sgstTax
        sgstTaxamount
        quantity
        calculatedAmount
        productDiscountPercentage
        productDiscount
        totalproductamount
      }
      features
      termsAndConditions
      totalCgstAmount
      totalSgstAmount
      subTotal
      totalAmount
    }
  }
`;
 
const NewQuationPage = ({ pdfRef }) => {
  const [quotationData, setQuatationData] = useState({
    quationno: "",
    quationDate: "",
    contact: "",
    placeofsupply: "",
    salesperson: "",
    product: [
      {
      cgstTax: "",
      sgstTax: "",
      }
 
    ],
    productDiscountPercentage: "",
    productDiscount: "",
    subTotal: "",
    totalCgstAmount: "",
    totalSgstAmount: "",
    totalAmount: "",
    features: "",
 
    shippingtitle: "",
    address1: "",
    address2: "",
    district: "",
    state: "",
    gstnumber: "",
  });
  
  const navigate = useNavigate();
 
  const { id } = useParams();
 
  useEffect(() => {
    if (id) {
      fetchValue();
    }
  }, [id]);
 
  const fetchValue = () => {
    request(BASEURL, qoutationpdf, { id: id }).then((res) => {
      const q = res?.getQuotationDetail;
      
      setQuatationData({
        quationno: q?.qtnid,
        quationDate: q?.quoteDate,
        contact: q?.preferredBy?.email,
        placeofsupply: "Tamil Nadu",
        salesperson: q?.preferredBy?.username,
        product: res.getQuotationDetail.quotationproductsSet.map((qs) => ({
          id: qs.id,
          productName: qs.productName?.productName || "-",  
          description: qs.productName?.description || "-",
          HSNNumber: qs.productName?.HSNNumber || "-",
          SKU: qs.productName?.SKU || "-",
          Tax: qs.productName?.Tax || 0,
          cgstTaxamount: qs.cgstTaxamount,
          sgstTaxamount: qs.sgstTaxamount,
          quantity: qs.quantity,
          rate: qs.calculatedAmount,
          totalproductamount: qs.totalproductamount,
          cgstTax: qs?.cgstTax,
          sgstTax: qs?.sgstTax,
          productDiscountPercentage: qs?.productDiscountPercentage,
          productDiscount: qs?.productDiscount,
 
        })),
        subTotal: q?.subTotal,
        
        totalCgstAmount: q?.totalCgstAmount,
        totalSgstAmount: q?.totalSgstAmount,
        totalAmount: q?.totalAmount,
        terms: q?.termsAndConditions,
        shippingtitle: q?.relatedName,
        address1: q?.billingAddress,
        features: q?.features,
        // address2: "1st floor Sukh building egmore",
        district: q?.customerCity + "-" + q?.customerZipcode,
        state: q?.customerState + "," + q?.customerCountry,
        gstnumber: q?.customerGst,
      });
    });
  };
 
 
  const htmlContent = `
  <style>
     ul {
    padding-left: 30px;
  }
  li {
    padding-left: 0;
    margin-left: 0;
  }
  </style>
  ${quotationData?.features}
`;
 
  return (
    <div
      ref={pdfRef}
      style={{
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "210mm",
 
        padding: "0",
        marginLeft: "10%",
      }}
    >
      <ReusablePDFLayout >
        <div className="quotationPdfBox" style={{ fontFamily: 'Outfit, sans-serif' }}>
          <div className="pdfheading">
            <div style={{ display: "flex", alignItems: "center" }}>
              <PdfLogo />
              <div style={{ marginLeft: "15px" }}>
                <h2>
                  keel info solution private limited
                </h2>
                <p>No 73,2nd floor, Santo Complex, ESIC Nagar,</p>
                <p>150 feet Agaram Main Road, </p>
                <p>Thiruvanchery, Chennai </p>
                <p>Tamil Nadu - 600 126, India</p>
                <p>GSTIN: 33AAJCK7889H1ZX</p>
              </div>
            </div>
            <h3>Quotation</h3>
          </div>
          <PdfSubheading
            quationno={quotationData.quationno}
            quationDate={quotationData.quationDate}
            contact={quotationData.contact}
            placeofsupply={quotationData.placeofsupply}
            salesperson={quotationData.salesperson}
          />
          <div
            style={{
              fontSize: "15px",
              fontWeight: "600",
              padding: "1px 6px",
              backgroundColor: "#e7e7e7",
              borderBottom: "solid 2px rgb(224, 224, 224)",
            }}
          >
            Bill To
          </div>
          <PdfShppingAddress
            title={quotationData.shippingtitle}
            address1={quotationData.address1}
            address2={quotationData.address2}
            state={quotationData.state}
            disrict={quotationData.district}
            gst={quotationData.gstnumber}
          />
          <div className="pdfpadding">
            <p style={{ fontSize: "13px", margin: "5px 0px" }}>Product :</p>
          </div>
          <PdfTabel product={quotationData.product} />
          <UnderTabelbox
            productDiscountPercentage={quotationData?.product[0].productDiscountPercentage}
            productDiscount={quotationData?.product[0].productDiscount}
            subTotal={quotationData.subTotal}
            totalCgstAmount={quotationData.totalCgstAmount}
            totalSgstAmount={quotationData.totalSgstAmount}
            totalAmount={quotationData.totalAmount}
            cgstTax={quotationData.product[0].cgstTax ?? 0}
            sgstTax={quotationData.product[0].sgstTax ?? 0}
          />
 
          <BankDeatils />
          <TermsAndConditionPdf terms={quotationData.terms} />
        </div>
      </ReusablePDFLayout>
      <ReusablePDFLayout
        headerstatus={true}
        footerstatus={true}
        padding={false}
      >
        <div
          dangerouslySetInnerHTML={{ __html: htmlContent }}
          style={{
            fontSize: "13px",
            padding: "0 15mm",
            margin: "5px 0px",
            maxHeight: "230mm",
            overflow: "hidden",
           fontFamily: 'Outfit, sans-serif',
           
          }}
        >
        </div>
      </ReusablePDFLayout>
    </div>
  );
};
 
export default NewQuationPage;